(function () {
  // 1) Find the header root (covers common themes)
  const header = document.querySelector('header.header, .site-header, header');
  if (!header) return;

  // 2) Try several likely selectors for the desktop nav container
  const FALLBACK_SELECTORS = [
    'nav[role="navigation"]',
    'nav[aria-label*="primary" i]',
    'nav[aria-label*="main" i]',
    '.header__inline-menu',
    '.site-nav',
    '.header__menu',
    '.menu--desktop',
    '[data-main-nav]',
  ];

  let nav = FALLBACK_SELECTORS.map(s => header.querySelector(s)).find(Boolean);

  // 3) If still not found, heuristically pick a wide element with lots of links
  if (!nav) {
    const candidates = Array.from(header.querySelectorAll('nav, ul, div')).filter(el => {
      const links = el.querySelectorAll('a').length;
      const style = getComputedStyle(el);
      const isRowish = /(row|flex)/i.test(style.display + ' ' + style.flexDirection);
      return links >= 5 && isRowish;
    });
    nav = candidates.sort((a,b) => b.scrollWidth - a.scrollWidth)[0] || null;
  }

  // Optional: support your <overflow-list> component if present
  const ol = document.querySelector('overflow-list');

  const BUFFER = 2;
  const inlineOverflowing = () => nav ? (nav.scrollWidth - nav.clientWidth) > BUFFER : false;

  const overflowListOverflowing = () => {
    if (!ol || !ol.shadowRoot) return false;
    const sr = ol.shadowRoot;
    const overflowList = sr.querySelector('[part="overflow-list"]');
    const moreSlot     = sr.querySelector('slot[name="more"]');
    const hasOverflowChildren = !!(overflowList && overflowList.childElementCount > 0);
    const moreVisible = !!(moreSlot && !moreSlot.hasAttribute('hidden'));
    return hasOverflowChildren || moreVisible;
  };

  const check = () => {
    const overflowing = inlineOverflowing() || overflowListOverflowing();
    header.classList.toggle('force-mobile', overflowing);
  };

  const observe = (el) => {
    if (!el) return;
    new ResizeObserver(check).observe(el);
    new MutationObserver(check).observe(el, { childList: true, subtree: true, attributes: true });
  };

  observe(nav);
  observe(ol);
  if (ol && ol.shadowRoot) {
    ['[part="list"]','[part="overflow-list"]','slot[name="more"]'].forEach(sel => {
      const el = ol.shadowRoot.querySelector(sel);
      observe(el);
    });
  }

  window.addEventListener('resize', check, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
  document.addEventListener('DOMContentLoaded', check);
  check();
})();
